import axios from "axios";

export async function postData(obj) {
  return await axios.post(`/report/update-scores`, obj);
}

export async function getData(reportName, grade) {
  return await axios.get(`/report/by-grade/${reportName}/${grade}`);
}

export async function getReportByPupil(reportName, pupil) {
  return await axios.get(`/report/by-pupil/${reportName}/${pupil}`);
}